import { Button, ButtonProps, Typography } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import React from 'react';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { colors } from '../styles/theme/colors';

type FavouritesButtonProps = {
    buttonProps?: ButtonProps;
    onClick: () => void;
};

export function FavouritesButton({ onClick, ...buttonProps }: FavouritesButtonProps) {
    const { t } = useServerTranslation();

    return (
        <Button
            variant="black"
            size="small"
            onClick={onClick}
            {...buttonProps}
            sx={{
                borderRadius: { xs: '50%', md: '2px' },
                padding: '6px',
                '&:hover': { backgroundColor: { md: colors.white }, color: { md: colors.pink2 } },
            }}
        >
            <Typography
                sx={{
                    component: 'div',
                    display: { xs: 'none', md: 'inline-block' },
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginRight: 0.5,
                }}
            >
                {t('menu.favourites')}
            </Typography>
            <FavoriteBorderIcon />
        </Button>
    );
}
